import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { components } from '@peachjar/components';

import GET_REGISTRATION_STATUS from './gql/schoolOrDistrictRegistration.query';
import OnboardingContainer from './OnboardingContainer';

const { Spinner } = components.LoadingIndicators;

const OnboardingContainerWrapper = ({ history, location, registrationId }) => {
  return registrationId ? (
    <Query query={GET_REGISTRATION_STATUS} variables={{ registrationId }}>
      {({ loading, error, data }) => {
        if (loading) return <Spinner />;
        if (error) return `Error! ${error.message}`;

        const registrationData = get(data, 'schoolOrDistrictRegistration');

        const {
          ncesSchoolId,
          ncesDistrictId,
          districtName,
          registrant,
          contactPhoneNumber,
          status,
        } = registrationData;

        if (status === 'verified') {
          return <Redirect to="onboarding/go-live" />;
        } else if (status === 'setup') {
          // the setup router will handle it from here
          return <Redirect to="onboarding/setup/school" />;
        } else if (status === 'sign-and-pay') {
          return <Redirect to="onboarding/payment" />;
        } else if (status === 'in-progress' || status === 'rfp') {
          return <Redirect to="/onboarding/payment" />;
        }
        return <OnboardingContainer />;
      }}
    </Query>
  ) : (
    <OnboardingContainer />
  );
};

const mapStateToProps = state => {
  return {
    registrationId: state.onboarding.registrationId,
  };
};

export default connect(mapStateToProps)(OnboardingContainerWrapper);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/OnboardingContainerWrapper.jsx